import { tokens } from '@danske/sapphire-css/themes';
import { RefObject, useLayoutEffect, useState } from 'react';

export type BreakpointKey = keyof typeof tokens.size.breakpoint;
export type Breakpoints = { [key in BreakpointKey]: number };

export const useBreakpointTokens = ({
  ref,
}: {
  ref: RefObject<HTMLElement>;
}): Breakpoints | undefined => {
  const [styles, setStyles] = useState<CSSStyleDeclaration | null>(null);

  useLayoutEffect(
    () => {
      if (ref.current) {
        setStyles(getComputedStyle(ref.current));
      }
    },
    [
      /**
       * don't need to re-calcaulate this.
       * The computed styles is a live object.
       * https://developer.mozilla.org/en-US/docs/Web/API/Window/getComputedStyle#return_value
       **/
    ]
  );

  return styles === null
    ? undefined
    : (Object.fromEntries(
        Object.entries(tokens.size.breakpoint).map(([name, { value }]) => {
          return [name, parseInt(styles.getPropertyValue(tokenName(value)))];
        })
      ) as Breakpoints); // Object.fromEntries/Object.entries loses type info;
};

/**
 * Takes a css var that looks like "var(--some-token-name)"
 * And returns "--some-token-name"
 */
const tokenName = (tokenCssValue: string) =>
  /var\((.*)\)/.exec(tokenCssValue)?.[1] || '';
